import translating from './translate.json';

const fields = [
  {
    name: 'name',
    label: translating.name,
    required: true,
    width: '100%'
  },
  {
    name: 'description',
    label: translating.description,
    required: true,
    breakLine: true,
    width: '100%'
  }
];

export default fields;
